//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//로딩 액션
import { AjaxLoading } from '../../../actions/Interactions/loading';
//데이터 API 목록
import { dataUrl } from '../dataUrl';

var currentAdvId = null;
var currentNaverId = null;
var neoIdList = {};
var naverIdList = {};

export const settingFunc = {
	init:function() {
		//this.naverSettingListData(advId);
	},
	callSettingByAdvId : function(adv_id){
		currentAdvId = adv_id;
		var dataApi = dataUrl.settingAPI('GET', 'naver', currentAdvId);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, settingFunc.initLinkSetting);

		dataApi = dataUrl.settingAPI('GET', 'filter', currentAdvId);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, settingFunc.initDuplicationSetting);
	},

	initLinkSetting : function(result){
		var naverIds = null;
		var neoIdArr = result.data.neo_list;;
		var firstNaverKey = null;
		naverIdList = {};
		neoIdList = {};

		if( result.data.hasOwnProperty('naver_list') ){ // 맵핑이 안된 경우
			naverIds = result.data.naver_list;
			firstNaverKey = naverIds[0];
			for(var idx=0; idx<naverIds.length; idx++){
				naverIdList[ naverIds[idx] ] = { count : 0 };
			}
				if( neoIdArr != undefined ){
				for(var idx=0; idx<neoIdArr.length; idx++){
					neoIdList[ neoIdArr[idx] ] = 'NA';
				}
			}
		}else{
			naverIds = result.data.match_list;
				if( neoIdArr != undefined ){
				for(var neoIdx=0; neoIdx<neoIdArr.length; neoIdx++){
					neoIdList[neoIdArr[neoIdx]] = 'NA';
				}
			}
				for(var naverId in naverIds){
				if( firstNaverKey == null ){
					firstNaverKey = naverId;
				}
					naverIdList[naverId] = { count : 0 };
				if( neoIdArr != undefined ){
					for(var nvIdx=0; naverIds[naverId]!=null&&nvIdx<naverIds[naverId].length; nvIdx++){
						naverIdList[naverId]['count']++;
						neoIdList[ naverIds[naverId][nvIdx] ] = naverId;
					}
				}
			}
		}


		settingFunc.clickNaverCampaign(firstNaverKey);
	},

	clickNaverCampaign : function(naverId){
		currentNaverId = naverId;

		var $onCampaign = $('.on_campaign');
		var $noCampaign = $('.no_campaign');

		var campaignRow = "<li>"
										+ "	<a href='javascript:void(0);' class='{{{clazz}}}' onclick='settingFunc.clickNaverCampaign(\"{{{naverId}}}\");' data-naver-id='{{{naverId}}}'>"
										+ "		{{{naverId}}}"
										+ "		<span class='campaignCount'>(<strong id='count-by-naver-id-{{{naverId}}}'>{{{count}}}</strong>)</span>"
										+ "	</a>"
										+ "</li>";
		var rows = '';
		for(var key in naverIdList){
			if( currentNaverId == key ){
				rows += campaignRow.replace(/{{{naverId}}}/g, key).replace(/{{{count}}}/g, naverIdList[key]['count']).replace('{{{clazz}}}','active');
			}else{
				rows += campaignRow.replace(/{{{naverId}}}/g, key).replace(/{{{count}}}/g, naverIdList[key]['count']).replace('{{{clazz}}}','');
			}
		}
		$onCampaign.find('ul').empty().append(rows);
		settingFunc.initNeoRows();
		settingFunc.calcSelectedNeoCountByNaverCampaign();
	},

	calcSelectedNeoCountByNaverCampaign : function(){
		try{
			for(var key in naverIdList){
				$('#count-by-naver-id-' + key).html(naverIdList[key]['count']);
			}
			settingFunc.showNaverCampaignArea();
			settingFunc.showNeoAccountArea();
			$('.no_special_characters').hide();
		}catch(e){
			settingFunc.showNoSpecialCharacterErrorArear();
		}
	},

	showNaverCampaignArea : function(){
		var $onNaver = $('.on_campaign');
		var $noNaver = $('.no_campaign');
		if( Object.keys(naverIdList).length > 0 ){
			$onNaver.show();
			$noNaver.hide();
		}else{
			$noNaver.show();
			$onNaver.hide();
		}
	},

	showNeoAccountArea : function(){
		var $onNeo = $('.on_neo');
		var $noNeo = $('.no_neo');
		if( Object.keys(neoIdList).length > 0 ){
			$onNeo.show();
			$noNeo.hide();
		}else{
			$noNeo.show();
			$onNeo.hide();
		}
	},

	showNoSpecialCharacterErrorArear : function(){
		alert('NAVER 캠페인명 또는 NEO 계정명에 띄어쓰기 또는\n허용되지 않는 특수문자가 포함되어있습니다.\n수정 후 다시 이용해주세요.');
		$('.on_campaign').hide();
		$('.no_campaign').hide();
		$('.on_neo').hide();
		$('.no_neo').hide();
		$('.no_special_characters').show();
	},



	initNeoRows : function(){
		var $onNeo = $('.on_neo');
		var $noNeo = $('.no_neo');

		var rows = '';

		var neoRow = "<li>"
							 + "	<input id='neo-id-{{{neoId}}}' type='checkbox' onclick='settingFunc.clickNeoCheckBox(this);' data-neo-id='{{{neoId}}}' {{{checked}}} {{{disabled}}}>"
					 		 + "		<label for='neo-id-{{{neoId}}}'>"
							 + "			<span>{{{neoId}}}</span>"
							 + "			<span class='naver-id-txt'>{{{naverId}}}</span>"
							 + "	</label>"
							 + "</li>"

		for(var key in neoIdList){
			if( currentNaverId == neoIdList[key] ){
				rows += neoRow.replace(/{{{neoId}}}/g, key)
											.replace(/{{{checked}}}/g, 'checked')
											.replace(/{{{disabled}}}/g, '')
											.replace(/{{{naverId}}}/g, '('+neoIdList[key]+')');
			}else if( 'NA' == neoIdList[key] ){
				rows += neoRow.replace(/{{{neoId}}}/g, key)
											.replace(/{{{checked}}}/g, '')
											.replace(/{{{disabled}}}/g, '')
											.replace(/{{{naverId}}}/g, '');
			}else{
				rows += neoRow.replace(/{{{neoId}}}/g, key)
											.replace(/{{{checked}}}/g, 'checked')
											.replace(/{{{disabled}}}/g, 'disabled')
											.replace(/{{{naverId}}}/g, '('+neoIdList[key]+')');
			}
		}
		$onNeo.find('ul').empty().append(rows);
	},

	clickNeoCheckBox : function(obj){
		var $this = $(obj);

		var currentNeoId = $this.data('neo-id');
		var checked = $this.prop('checked');
		var disabled = $this.prop('disabled');

		if( disabled == false ){
			if( checked == true ){
				naverIdList[currentNaverId]['count']++;
				neoIdList[currentNeoId]=currentNaverId;
				$this.closest('li').find('.naver-id-txt').text('('+ neoIdList[currentNeoId]+')');
			}else{
				neoIdList[currentNeoId]='NA';
				naverIdList[currentNaverId]['count']--;
				$this.closest('li').find('.naver-id-txt').empty();
			}
			settingFunc.calcSelectedNeoCountByNaverCampaign();
		}
	},


	initDuplicationSetting:function(result){
		var $neoDupleCheckBoxes = $('.neoDupleCheckbox').prop('checked',false);
		if( result.data != null ){
			var ndfArr = result.data.neo_duple_fields.split(",");
			$neoDupleCheckBoxes.each(function(index){
				for(var idx=0; idx<ndfArr.length; idx++){
					if( ndfArr[idx] == $(this).val() ){
						$(this).prop('checked',true);
						break;
					}
				}
			});
		}
	},

	save:function() {
		var sendData = {
			adv_id : currentAdvId,
			rept_match_type : {
				'neo_field_type' : 'neo_account_nm',
				'cus_field_type' : 'campaign_nm'
			}
		}

		var neoStr = '';
		var matchOne = '';
		var matches = '';
		for(var naverKey in naverIdList){
			matchOne = '';
			neoStr = '';
			for(var neoKey in neoIdList){
				if( naverKey == neoIdList[neoKey] ){
					neoStr += neoKey + ",";
				}
			}
			if( neoStr != '' ){
				neoStr = neoStr.substring(0,neoStr.length-1)
				matchOne = {
					naver : naverKey,
					neo : neoStr
				}
				matches += (JSON.stringify(matchOne) + ',');
			}
		}
		matches = matches.substring(0, matches.length-1);
		sendData.rept_match_type.match_list = JSON.parse('['+ matches +']');



		if( sendData.rept_match_type.match_list.length == 0 ){
			alert('NAVER 캠페인과 NEO 계정이 최소 하나는 맵핑되어야합니다.');
			return;
		}

		var checkedNeoDupls = '';
		$('.neoDupleCheckbox').each(function(index){
			if( $(this).prop('checked') ){
				checkedNeoDupls += ($(this).val() + ',');
			}
		});
		if( checkedNeoDupls != '' ){
			checkedNeoDupls = checkedNeoDupls.substring(0, checkedNeoDupls.length-1);
		}

		sendData.rept_config = {
			neo_duple_fields : checkedNeoDupls
		}

		var dataApi = dataUrl.settingAPI('POST', 'save');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, settingFunc.saveCallback, sendData);
	},

	saveCallback : function(result){
		if( result.success == true ){
			alert('저장되었습니다.');
		}else{
			console.log(result.msg);
			alert('저장에 실패하였습니다.')
		}
	}
}

window.settingFunc = settingFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/sub/settingFunc.js